import { render } from "./InputMultipleAnswersDev.vue?vue&type=template&id=ec85ce16"
import script from "./InputMultipleAnswersDev.vue?vue&type=script&lang=js"
export * from "./InputMultipleAnswersDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__